import { ValueOf } from '../../utilities/types';

const stepUpActions = {
  REPLACE_DEVICE: 'replace-device',
  REGENERATE_RECOVERY_CODES: 'regenerate-recovery-codes',
  DISABLE: 'disable',
  LOWER_ACCOUNT_REQUIREMENT: 'lower-account-requirement',
} as const;

export type StepUpAction = ValueOf<typeof stepUpActions>;

export const canDisableMfa = ({
  enabled,
  required,
}: {
  enabled: boolean;
  required: boolean;
}): boolean => enabled && !required;

export default stepUpActions;
